import React, { useEffect } from 'react';
import InputType from './ComponentsTpes/InputType';

const PassControl = ({  fieldsData, componentSourceOptions ,selectedPorts,
     setSelectedPorts, savedData, setSavedData}) => {

    const selectOptions = (key, value) => {
        setSavedData(prevData => {
            return {
                ...prevData,
                Pass_control:{
                    ...prevData.Pass_control,
                    [key]: value
                }
            }
        })
    }

    return (<InputType
        setSelectedPorts={setSelectedPorts}
        selectedPorts={selectedPorts}
        source={componentSourceOptions.inputsData}
        selectOptions={selectOptions}
        component_source={savedData.Pass_control.component_source.value}
        condition={savedData.Pass_control.condition}
        input={savedData.Pass_control.input}
        name={savedData.Pass_control.name}
        fieldsData={fieldsData}
    />)
}

export default PassControl;